module.exports = __webpack_public_path__ + "static/media/ams-success-navy-blue.efe82239.gif";